import React from 'react'

import { Typography, colors } from '@material-ui/core'

import { ConfirmationDialog } from 'components'

const FieldEditConfirmDialog = ({
  pendingFieldEditPayload,
  setPendingFieldEditPayload,
  onConfirm,
}) => (
  <ConfirmationDialog
    open={Boolean(pendingFieldEditPayload)}
    setOpen={(value) => {
      if (!value) setPendingFieldEditPayload(null)
    }}
    actionAcceptButton={onConfirm}
    textButton="Prosseguir"
    textButtonCancel="Voltar"
    accentColor={colors.pink[900]}
    text={
      <Typography variant="body1">
        Esta é uma atividade automatizada. Se você alterar esses campos, eles
        deixarão de ser atualizados pelo sistema, embora a atividade continue
        avançando pelo fluxo automático.
        <br />
        <br />
        Tem certeza que deseja prosseguir?
      </Typography>
    }
  />
)

export default FieldEditConfirmDialog
